(function() {
	angular.module('ShargoApp')
		.service('MGMService', function($http, Configuration) {
			var svc = {};

			svc.getReferralInfo = function(MGMCode) {
				console.log("GET REFERRAL INFO CODE", MGMCode);
				return $http.get(Configuration.apiUrl + '/referralinfo?ref=' + MGMCode)
					.then(function(response) {
						console.log("REFERRAL INFO SUCCESS", response);
						return response.data;
					},
					function(data) {
						console.log("REFERRAL INFO FAIL", data);
						return { firstName: 'Shargo' };
					});
			};

			svc.sendMGMMail = function(email) {
				var params = {
					to: email
				};
				return $http.post(Configuration.apiUrl + '/senders/invitefriend', params, {
					headers: {
						'x-token': localStorage.getItem('xtoken'),
						'x-userid': localStorage.getItem('userid')
					}
				}).then(function successCallback(res) {
					console.log("sendMGMMail > successCallback: ", res);
					return res.status;
				}, function errorCallback(e) {
					console.log("sendMGMMail error: ",e);
					return 'ko';
				});
			};

			return svc;
		})

		.controller('MGMRegisterController', function($scope, $rootScope, $routeParams, $anchorScroll, toolsService, Configuration, MGMService, AuthService){
			$rootScope.pageConfiguration = {
				footer: true,
				header: {
					solid: $rootScope.device.isDesktop ? 380 : 260,
					background: 'linear-gradient(to bottom, #fed256, #ffbd4d)',
					preheader: false,
					headerLink: $rootScope.url('home'),
					headerLogo: $rootScope.device.isDesktop ? Configuration.siteDomain + "/img/header/shargo-white.svg" : Configuration.siteDomain + "/img/header/shargo-mobile.svg",
					logIn: false,
					dashboard: true,
					callToAction: {
						link: AuthService.isAuthenticated() ? $rootScope.device.isDesktop ? $rootScope.url('sendpackage') : $rootScope.url('contact') : '',
						text: AuthService.isAuthenticated() ? $rootScope.device.isDesktop ? 'header.ask4Shargo' : 'header.contact' : '',
						target: '',
						hide: AuthService.isAuthenticated() ? false : true,
						disabled: false
					},
					profile: true
				}
			};

			/*  --VARIABLES--  */
			$scope.authenticated = false;
			$scope.referral = {
				name: "",
				code: $routeParams.code,
				registered: false
			};


			/*  --FUNCTIONS-- */


			/*  --EXECUTION--  */
			MGMService.getReferralInfo($scope.referral.code).then(function(response) {
				$scope.referral.name = response.firstName;
			});

			$scope.scrollMobile = function() {
				if ($rootScope.device.isPhone){
					$anchorScroll();
				}
			};

			if(AuthService.isAuthenticated()){
				$scope.authenticated = true;
			}
		});
})();